import React, { Component } from "react";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from "@material-ui/core/LinearProgress";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import qs from "qs";
import _ from "lodash";
import http from "../../util/http";
import PlayerDropdownSearch from "../PlayerDropdownSearch";
import PlayerAnalysisResult from "./PlayerAnalysisResult";
import { MuiThemeProvider } from "@material-ui/core/styles";
import aceTheme from "../../util/aceTheme";

const periods = [
  { label: "Lifetime", value: "0" },
  { label: "Year", value: "-365" },
  { label: "6 Months", value: "-180" },
  { label: "3 Months", value: "-90" },
  { label: "1 Month", value: "-30" },
  { label: "1 Week", value: "-7" },
  { label: "This NFL Season", value: "1" },
  { label: "Last NFL Season", value: "2" },
];

const types = [
  { label: "Summary", value: "SUMMARY" },
  { label: "Sports", value: "SPORTS" },
  { label: "Periods", value: "PERIODS" },
  { label: "Wager Type", value: "WAGERTYPE" },
  { label: "Horses", value: "HORSES" },
  { label: "Casino", value: "CASINO" },
  { label: "Live Casino", value: "LIVECASINO" },
  { label: "Deluxe Casino", value: "DELUXE" },
];

const getCategoryList = (playerAnalysisData) => {
  const categoryArray = [];
  _.each(playerAnalysisData, (groupData) => {
    const categorySet = new Set();
    const analysisList = _.flatten(_.values(groupData.Time));
    _.each(analysisList, (analysisData) => {
      categorySet.add(analysisData.Title);
    });
    categoryArray.push(Array.from(categorySet));
  });
  return categoryArray;
};

const fillPlayerAnalysisData = (playerAnalysisData, categoryList) => {
  const filledPlayerData = _.map(playerAnalysisData, (groupData, i) => {
    let timeData = _.clone(groupData.Time);
    timeData = _.map(timeData, (timeObj) => {
      let timeObjAllItems = _.clone(timeObj);
      const titlesLeft = _.difference(categoryList[i], _.map(timeObj, "Title"));
      if (titlesLeft.length) {
        const titlesLeftObjects = _.map(titlesLeft, (titleLeft) => ({
          ...timeObjAllItems[0],
          Title: titleLeft,
          NumberOfWagers: 0,
          Volume: 0,
          WinAmount: 0,
          LostAmount: 0,
          Earnings: 0,
          Hold: 0,
        }));
        timeObjAllItems = _.chain(timeObjAllItems)
          .concat(titlesLeftObjects)
          .orderBy("Title")
          .value();
      }
      return timeObjAllItems;
    });
    groupData.Time = timeData;
    return groupData;
  });
  return filledPlayerData;
};

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 0,
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class PlayerAnalysisForm extends Component {
  state = {
    reasonVoid: "Perform a Search",
    searchingAnalysis: false,
    periodList: ["6 Months"],
    typeList: ["Sports"],
    selectedPlayer: "",
    analysisData: [],
  };
  componentDidMount() {
    const parsedQueryString = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    if (parsedQueryString.user) {
      this.setState({ selectedPlayer: `${parsedQueryString.user}|` });
      setTimeout(() => {
        this.searchPlayerAnalysis("name");
      }, 1000);
    }
  }
  handleChange = (event) => {
    this.setState({ name: event.target.value });
  };
  handlePeriodChange = (event) => {
    this.setState({ periodList: event.target.value });
  };
  handleTypeChange = (event) => {
    this.setState({ typeList: event.target.value });
  };
  searchPlayerAnalysis = async (mode) => {
    try {
      if (mode !== "name") {
        mode = "id";
      }
      this.setState({
        reasonVoid: "Searching...",
        searchingAnalysis: true,
        analysisData: [],
      });
      const operationValues = _.chain(types)
        .filter((type) => _.includes(this.state.typeList, type.label))
        .map("value")
        .value();
      const daysValues = _.chain(periods)
        .filter((period) => _.includes(this.state.periodList, period.label))
        .map("value")
        .value();

      // await http.sendCommand("command:player:summaryReportMultiPeriodsMultiOperations"
      const payloadPlayerAnalysis = JSON.stringify({
        Operation: operationValues.join(),
        IdPlayer: this.state.selectedPlayer.split("|")[0],
        Mode: mode,
        Days: daysValues.join(),
      });
      const playerAnalysis = await http.sendHelperCommand(
        "PlayerAnalysisHelper.aspx",
        { payload: payloadPlayerAnalysis }
      );
      const analysisByOperation = _.groupBy(playerAnalysis, "Operation");
      const analysisByOperationByTime = _.map(
        analysisByOperation,
        (arrayOperation, keyOperation) => {
          return {
            Operation: keyOperation,
            Time: _.groupBy(arrayOperation, "TimeName"),
          };
        }
      );
      const fullCategoryListData = getCategoryList(
        _.cloneDeep(analysisByOperationByTime)
      );
      const filledAnalysisData = fillPlayerAnalysisData(
        _.cloneDeep(analysisByOperationByTime),
        fullCategoryListData
      );
      this.setState({
        reasonVoid: "Data not found",
        analysisData: filledAnalysisData,
        searchingAnalysis: false,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        analysisData: [],
        searchingAnalysis: false,
      });
    }
  };
  render() {
    const { classes, prmIdAgent } = this.props;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div style={{ minHeight: 450 }}>
          <form autoComplete="off" className={classes.container}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="select-multiple-period">Period</InputLabel>
              <Select
                multiple
                value={this.state.periodList}
                onChange={this.handlePeriodChange}
                input={<Input id="select-multiple-period" />}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((value) => (
                      <Chip
                        color="primary"
                        key={value}
                        label={value}
                        className={classes.chip}
                      />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {periods.map((period) => (
                  <MenuItem key={period.value} value={period.label}>
                    <Checkbox
                      checked={_.includes(this.state.periodList, period.label)}
                    />
                    <ListItemText primary={period.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="select-multiple-type">Type</InputLabel>
              <Select
                multiple
                value={this.state.typeList}
                onChange={this.handleTypeChange}
                input={<Input id="select-multiple-type" />}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((value) => (
                      <Chip
                        color="primary"
                        key={value}
                        label={value}
                        className={classes.chip}
                      />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {types.map((type) => (
                  <MenuItem key={type.value} value={type.label}>
                    <Checkbox
                      checked={_.includes(this.state.typeList, type.label)}
                    />
                    <ListItemText primary={type.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              className={classes.formControl}
              style={{ marginTop: 2 }}
            >
              <PlayerDropdownSearch
                agentFilter={true}
                displayAllPlayers={false}
                onEnter={this.searchPlayerAnalysis}
                prmIdAgent={prmIdAgent}
                onSelectPlayer={(selectedPlayer) => {
                  this.setState({ selectedPlayer });
                }}
              />
            </FormControl>
            <FormControl style={{ marginTop: 30 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={this.searchPlayerAnalysis}
              >
                Search
              </Button>
            </FormControl>
          </form>
          {this.state.searchingAnalysis && (
            <LinearProgress className={classes.progressLinear} />
          )}
          <PlayerAnalysisResult
            {...{
              analysisData: this.state.analysisData,
              reasonVoid: this.state.reasonVoid,
            }}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

PlayerAnalysisForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  prmIdAgent: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(PlayerAnalysisForm);
